module.exports = __webpack_public_path__ + "img/status_preparing_pan.8ae913c8.png";